import { S3FileService } from 'src/services/s3FileService';
import { StringConstants } from '../constant/stringConstants';
const { v4: uuidv4 } = require('uuid');

const cleanFileName = (originalName: string): string => {
  const lastDotIndex = originalName.lastIndexOf('.');

  if (lastDotIndex === -1) {
    return originalName.replace(/[!@#$%^&*()+\-=\[\]{};':"\\|,<>\?/ ]/g, '_');
  }

  const namePart = originalName.substring(0, lastDotIndex);
  const extPart = originalName.substring(lastDotIndex);

  const cleanedName = namePart.replace(/[!@#$%^&*()+\-=\[\]{};':"\\|,<>\?/ ]/g, '_');

  return cleanedName + extPart;
};

const getFileKey = (
  prefix: string,
  originalFileName: string) => {
  return prefix
    + '/'
    + uuidv4()
    + StringConstants.UNDERSCORE
    + originalFileName;
};

export const addFileToS3 = async (
  prefix: string,
  originalFile: File,
  onProgress?: (e: { percent: number }) => void
): Promise<string> => {
  return new Promise(async (resolve, reject) => {
    try {
      const fileKey =
        getFileKey(
          prefix,
          cleanFileName(originalFile.name));

      const presignedUrl =
        await S3FileService.getPresignedPutUrl({
          fileKey,
          contentType: originalFile.type,
        });

      const xhr = new XMLHttpRequest();
      xhr.open('PUT', presignedUrl, true);
      xhr.setRequestHeader('Content-Type', originalFile.type);
      xhr.setRequestHeader('x-amz-acl', 'public-read');

      xhr.upload.onprogress = function (event) {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);

          onProgress?.({ percent });
        }
      };

      xhr.onload = function () {
        if (!(xhr.status >= 200 && xhr.status < 300)) {
          reject(`Upload failed with status ${xhr.status}`);
          return;
        }

        resolve(fileKey);
      };

      xhr.onerror = function () {
        reject('Upload failed (network error)');
      };

      xhr.send(originalFile);
    } catch (err) {
      reject(err);
    }
  });
};
